export const SERVERLESS_URL = "https://3d-serverless-eight.vercel.app";

// --- Generation wait experience ---

/** After this many seconds, the progress panel switches to "taking longer than usual" messaging. */
export const GENERATION_OVERDUE_SECONDS = 90;

/** After this many seconds, the client stops waiting and shows an honest timeout message. */
export const GENERATION_TIMEOUT_SECONDS = 240;

/** Client-side upload size limit. The dropzone copy must match this value. */
export const MAX_UPLOAD_BYTES = 20 * 1024 * 1024;

export interface GenerationStage {
  label: string;
  /** Elapsed seconds at which this stage becomes the current one (time-driven narration, not backend telemetry). */
  atSeconds: number;
}

/**
 * Stage narration for the image-to-3D flow. Only "Uploading your image" is tied to a real
 * signal (pinned until the job record exists); later labels are time-based narration of the
 * pipeline's known phases. No percentages are shown anywhere — the backend emits none.
 */
export const IMAGE_TO_3D_STAGES: GenerationStage[] = [
  { label: "Uploading your image", atSeconds: 0 },
  { label: "Analyzing image", atSeconds: 5 },
  { label: "Reconstructing geometry", atSeconds: 20 },
  { label: "Generating textures", atSeconds: 45 },
  { label: "Finishing up", atSeconds: 75 },
];

/** Stage narration for the character generator flow. Upload/queued stages are pinned to real signals. */
export const CHARACTER_STAGES: GenerationStage[] = [
  { label: "Uploading images", atSeconds: 0 },
  { label: "Queued for processing", atSeconds: 5 },
  { label: "Generating character model", atSeconds: 15 },
  { label: "Refining details", atSeconds: 60 },
];

/** Input-quality tips rotated during the wait; doubles as guidance for better results. */
export const INPUT_QUALITY_TIPS = [
  "Best results come from a single subject centered in the frame.",
  "Plain, uncluttered backgrounds help the model separate your subject cleanly.",
  "Well-lit, sharp photos produce more detailed geometry and textures.",
  "A front-facing or three-quarter angle captures the most usable shape.",
  "PNG or JPG up to 20MB — higher resolution images give better textures.",
];
